export default "__VITE_ASSET__LqF4f0Qi__"